import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { ConditionalWrapper } from '@uswitch/ev-utils/conditional-wrapper';
import HeaderFooterWrapper from './header-footer-wrapper';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var withComponentBase = function withComponentBase(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (props) {
    if (typeof options === 'function') {
      options = options(props);
    }

    var _ref = typeof options === 'function' ? options(props) : options,
        _ref$withHeaderFooter = _ref.withHeaderFooter,
        withHeaderFooter = _ref$withHeaderFooter === void 0 ? false : _ref$withHeaderFooter,
        headerStyles = _ref.headerStyles,
        footerStyles = _ref.footerStyles,
        headerContainerStyles = _ref.headerContainerStyles,
        footerContainerStyles = _ref.footerContainerStyles,
        _ref$wrapHeaderFooter = _ref.wrapHeaderFooterChildren,
        wrapHeaderFooterChildren = _ref$wrapHeaderFooter === void 0 ? false : _ref$wrapHeaderFooter;

    return _jsx(ConditionalWrapper, _objectSpread(_objectSpread({
      condition: withHeaderFooter,
      wrapper: HeaderFooterWrapper,
      headerStyles: headerStyles,
      footerStyles: footerStyles,
      wrapChildren: wrapHeaderFooterChildren,
      headerContainerStyles: headerContainerStyles,
      footerContainerStyles: footerContainerStyles
    }, props), {}, {
      children: _jsx(Component, _objectSpread({}, props))
    }));
  };
};

export default withComponentBase;
//# sourceMappingURL=index.js.map